<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card class='mb-2'>
                  <v-card-title class="text-xs-center" style="font-size: 2rem">
                    Cadastro de programas
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-container fluid>
                        <v-form v-model="valid" ref="form" lazy-validation >
                          <v-flex xs12>
                            <v-text-field
                            label="*Nome"
                            v-model="programaData.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            :counter="50"
                            maxlength="50"
                            required
                            ></v-text-field>
                            <v-textarea
                            name="Descricao"
                            v-model="programaData.description"
                            label="Descrição"
                            maxlength="1200"
                            :counter="1200"
                            ></v-textarea>
                            <v-autocomplete
                              label="*Ano"
                              :items="ano"
                              item-text="name"
                              item-value="name"
                              multiple
                              v-model="programaData.ano"
                              max-height="400"
                              hint="Escolha o ano"
                              persistent-hint
                              required
                              :rules="[ value => value.length >= 1 || 'Unidade é obrigatória.']"
                            ></v-autocomplete>
                          </v-flex>
                        </v-form>
                      </v-container>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn 
                      color="info" 
                      @click="performSave"
                      :loading="animation" 
                      :disabled="!valid">
                        <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                          <span v-else>
                            Enviar
                          </span>
                          </v-btn>
                  </v-card-actions>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  data () {
    return {
      programaData: {},
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      selectedFile: {},
      editing: false,
      animation: false,
      tempData: {},
      options: {},
      unidade: [],
      ano: {},
      path: '',
      valid: true,
      loading: false
    }
  },
  created () {
    let username = this.$store.state.user.username
    api.request('GET', 'user-edit-options/' + username + '/').then((response) => {
      this.options = response.data
      console.log(this.options)
    })
    api.request('GET', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = response.data
    })
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade)
    },
    getUserImage (username) {
      var userarray = this.programaData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0].profilePic
    },
    performSave () {
      if (this.$refs.form.validate()) {
        this.animation = true
        let self = this
        api.request('POST', 'programas/', self.programaData).then(function (response) {
          if (response.data.slug) {
            console.log(response.data)
            let name = '/programas/' + response.data.slug + '/'
            self.animation = false
            self.$router.push(name)
          } else {
            console.log(response)
            self.animation = false
          }
        }).catch(function (error) {
          console.log(error)
          self.animation = false
        })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Programa/Cadastro.vue